// Configurable static image path using environment variable
export const STATIC_BASE_PATH = process.env.STATIC_BASE_PATH || '/static/images';
export const staticImage = (path: string): string => `${STATIC_BASE_PATH}/${path}`;

// Configurable backend URL using environment variable
export const BACKEND_BASE_URL = process.env.BACKEND_BASE_URL || 'http://127.0.0.1:8500';

// Configurable main website URL for authentication
export const MAIN_WEBSITE_URL = process.env.MAIN_WEBSITE_URL || 'https://www.wwxplorer.com';
